module.exports = __webpack_public_path__ + "img/emoji-shrugging-80x80.1b76a9bb.png";